import relatorioExameBloqueado from './relatorioExameBloqueado'
import relatorioPacienteAtendido from './relatorioPacienteAtendido'
import parametrizacao from './parametrizacao'
import formulaExame from './formulaExame'
import jornada from './jornada'
import agendamentoExame from './agendamentoExame'
import lancamentoColeta from './lancamentoColeta'
import lancamentoResultado from './lancamentoResultado'
import assinaturaEletronica from './assinaturaEletronica'
import mapaProducao from './mapaProducao'
import impressaoExame from './impressaoExame'
import importarLaudo from './importarLaudo'
import entregaExame from './entregaExame'
import exameAgendadoRealizado from './exameAgendadoRealizado'
import impressoes from './impressoes'
import coletaAgendada from './coletaAgendada'
import mapaDia from './mapaDia'
import agendamentoExameRetroativo from './agendamentoExameRetroativo'
import cancelamentoResultado from './cancelamentoResultado'
import relatorioCotaConsumo from './relatorioCotaConsumo'
import exameSolicitadoStatus from './exameSolicitadoStatus'
import exameProducao from './exameProducao'
import relatorioFinanceiroPaciente from './relatorioFinanceiroPaciente'
import relatorioColetaRealizada from './relatorioColetaRealizada'
import relatorioFinanceiroExame from './relatorioFinanceiroExame'
import relatorioHistoricoPaciente from './relatorioHistoricoPaciente'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducao'
import relatorioQuantitativoExameSolicitado from './relatorioQuantitativoExameSolicitado'
import relatorioExameLaboratorioApoio from './relatorioExameLaboratorioApoio'

export default [
    {
        path: 'exame-laboratorial',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...relatorioExameBloqueado,
            ...relatorioPacienteAtendido,
            ...parametrizacao,
            ...formulaExame,
            ...jornada,
            ...agendamentoExame,
            ...lancamentoColeta,
            ...lancamentoResultado,
            ...assinaturaEletronica,
            ...mapaProducao,
            ...impressaoExame,
            ...importarLaudo,
            ...entregaExame,
            ...exameAgendadoRealizado,
            ...impressoes,
            ...coletaAgendada,
            ...mapaDia,
            ...agendamentoExameRetroativo,
            ...cancelamentoResultado,
            ...relatorioCotaConsumo,
            ...exameSolicitadoStatus,
            ...exameProducao,
            ...relatorioFinanceiroPaciente,
            ...relatorioColetaRealizada,
            ...relatorioFinanceiroExame,
            ...relatorioHistoricoPaciente,
            ...relatorioQuantitativoProducao,
            ...relatorioQuantitativoExameSolicitado,
            ...relatorioExameLaboratorioApoio,
        ]
    }
]